import React, { useState } from "react";
import { ScreenComponent, ScreenProps } from "../types";
import "./index.css";
import SelectionChoices from "./SelectionChoices";
import {
  ConfirmButton,
  SelectionInput,
  SelectionPick,
  SelectionTabs
} from "./SelectionComponents";
import SelectionFilter from "./SelectionFilter";
import useSelection from "./useSelection";

const Selection: ScreenComponent = (props: ScreenProps) => {
  const [text, setText] = useState("");

  const defaultFilter = () => true;
  const [filter, setFilter] = useState(() => defaultFilter);

  const { dispatch, state } = props;
  const { tabProps, gambitProps, setPick } = useSelection(state);
  const { tabs, setTab, tab, choices } = tabProps;
  const { gambit, isReady } = gambitProps;
  const onConfirm = () => dispatch({ type: "updateGambit", payload: gambit });

  return (
    <div id="gambit-selection">
      <SelectionTabs tabs={tabs} tab={tab} setTab={setTab} />
      <SelectionPick gambit={gambit} />
      <SelectionInput text={text} onChange={e => setText(e.target.value)} />
      <SelectionFilter tab={tab} setFilter={setFilter} />
      <SelectionChoices
        text={text}
        choices={choices}
        setPick={setPick}
        filter={filter}
      />
      <ConfirmButton isReady={isReady} clickHandler={onConfirm} />
    </div>
  );
};

export default Selection;
